import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Table } from 'primeng/table';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TitleCasePipe } from '@angular/common';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { LazyLoadEvent } from 'primeng/api';
import { saveAs } from 'file-saver/src/FileSaver';
import * as moment from "moment";
import { environment } from 'src/environments/environment';
import { Dropdown } from "primeng/dropdown";
import { AcademypaymentService } from 'src/app/services/academyPayment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-academypaymentdetails',
  templateUrl: './academypaymentdetails.component.html',
  styleUrls: ['./academypaymentdetails.component.scss'],
  providers: [MessageService, ConfirmationService, TitleCasePipe]
})

export class AcademyPaymentDetailsComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>(); 
  public academypaymentlist: any = [];
  public downloadacademypaymentlist: any = [];
  public loading: boolean;
  public totalRecords = 0;
  errorMessage: string;
  public loggedInUser;
  paginationOption;
  yearRange;
  minYear = environment.minYear;
  startDate: Date;
  searchby;
  searchBy: any[];
  username: string;
  totalCoins;
  totalDeductedCoin;
  totalAvailableCoins;
  totalCash;
  totalDeductedCash;
  totalAvailableCash;
  description:any;
  endDate: Date;
  downloadFlg: boolean;
  public lastTableLazyLoadEvent: LazyLoadEvent;
  public userId;
  public loggedInUserId;
  public loggedInUserData;
  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId", { static: false }) pDropDownId: Dropdown;
  downloadwalletlist: any = [];
  constructor(
    private tokenStorageService: TokenStorageService,
    private academypaymentService: AcademypaymentService,
    private router: Router, private activeroute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.paginationOption = environment.pagination;
    this.loggedInUserData = this.tokenStorageService.getUser();
    this.loggedInUserId = this.loggedInUserData.userdata['id'];
    console.log(this.loggedInUserId);
    this.userId = this.activeroute.snapshot.params.id;
    this.searchBy = [
      { label: 'Created On', value: "created_at" },
      // { label: 'Last Modified On', value: "updated_at" }
    ];

    this.description = [
      { label: "Tournament Registration Fees", value: "Tournament Registration Fees" },
      { label: "Player registered for Tournament", value: "Player registered for Tournament" },
      { label: "Find a Partner Fees", value: "Find a Partner Fees" },
      { label: "Cash Credited On schdeule Registration", value: "Cash Credited On schdeule Registration" },

    ];
    this.downloadFlg = false;
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = '';
    this.dt.filter('', 'mobileNumber', 'contains');
    this.dt.filter('', 'paymentId', 'contains');
    this.dt.filter('', 'amount', 'contains');
    this.dt.sortField = null;
    this.dt._first = 0;
    this.dt._rows = 10;
   // this.pDropDownId.clear(null);
    if (this.pDropDownId) {
      this.pDropDownId.value = "";
    }

  }
  addNewWallet() {
    this.router.navigate(['/manage/customer/user/wallet/add/' + this.userId]);
  }

  setDownloadFlag() {
    this.downloadFlg = false;
  }
  loadAcademyPaymentHistory(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    var query = "?"; //&filterByUserid=" + this.userId;
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = (event.first / event.rows) + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 100;
    }
    if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
      params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }
    // if (event.filters != undefined && event.filters["id"] != undefined) {
    //   params += "&filterById=" + event.filters["id"].value;
    // }
    // if (event.filters != undefined && event.filters["userName"] != undefined) {
    //   params += "&filterByName=" + event.filters["userName"].value;
    // }
    // if (event.filters != undefined && event.filters["userEmail"] != undefined) {
    //   params += "&filterByEmail=" + event.filters["userEmail"].value;
    // }
    if (event.filters != undefined && event.filters["mobileNumber"] != undefined) {
      params += "&filterByMobileNumber=" + event.filters["mobileNumber"].value;
    }
    if (event.filters != undefined && event.filters["paymentId"] != undefined) {
      params += "&filterByPaymentId=" + event.filters["paymentId"].value;
    }
    if (event.filters != undefined && event.filters["amount"] != undefined) {
      params += "&filterByAmount=" + event.filters["amount"].value;
    }

    // if (event.filters != undefined && event.filters["description"] != undefined) {
    //   params += "&filterByDescription=" + event.filters["description"].value;
    // }
    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    this.academypaymentService.getAcademyPaymentList(query).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        this.loading = false;
        // this.username = data.data.userInfo['name'];
        // this.totalCash = data.data.totalCash;
        // this.totalDeductedCash = data.data.totalDeductedCash;
        // this.totalAvailableCash = this.totalCash - this.totalDeductedCash;
        // this.totalCoins = data.data.totalCoins;
        // this.totalDeductedCoin = data.data.totalDeductedCoin;
        // this.totalAvailableCoins = this.totalCoins - this.totalDeductedCoin;
        if(this.downloadFlg === true) {
          this.exportExcelsheet(data.data.items);
        } else {
          this.academypaymentlist = data.data.items;
          this.totalRecords = data.data.totalCount;
        }

      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
    
 
  exportExcel() {
   this.downloadFlg = true;
   this.loadAcademyPaymentHistory(this.lastTableLazyLoadEvent);
  }

  exportExcelsheet(walletlist){
    var propertiesRemove = ['academiesdata', 'academyId', 'email', 'expiryDate', 'invoiceFile', 'invoiceId', 'membershipType', 'orderId', 'receiptId','status','userdetails'];
    this.downloadwalletlist = walletlist;
    this.downloadwalletlist.forEach(function (item) {
      if (item.created_at != '') {
        item['created_at'] = moment(item.created_at).format('DD-MM-YYYY');
      }
      propertiesRemove.forEach(function (prop) {
        delete item[prop];
      });
    });

    const columnMapping = {
      'id': 'Transacion ID',
      'academyName': 'Academy Name',
      'mobileNumber':'Mobile Number',
      'paymentId':'paymentId',
      'amount': 'Amount',
      'created_at': 'Created Date'
    };
  
    import("xlsx").then(xlsx => {
      const downloadwalletlistWithHeaders = this.downloadwalletlist.map(item => {
        const newItem = {};
        for (const key in item) {
          if (columnMapping.hasOwnProperty(key)) {
            newItem[columnMapping[key]] = item[key];
          }
        }
        return newItem;
      });
  
      const worksheet = xlsx.utils.json_to_sheet(downloadwalletlistWithHeaders);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, { bookType: "xlsx", type: "array" });
      this.saveAsExcelFile(excelBuffer, "Payment Details");
    });
    this.downloadFlg = false;
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      let filename;
      filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
      saveAs(data, filename);
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  
}